<div class="grid-container">
  <div class="card">
    <div class="card-title"><p>Incidencias Totales</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
          ></path>
          <path
            d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
          ></path>
          <path d="M9 12h6"></path>
          <path d="M9 16h6"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.incidents }}</div>
    </div>
  </div>

  <div class="card">
    <div class="card-title"><p>Incidencias Activas</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
          ></path>
          <path
            d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
          ></path>
          <path d="M9 12h6"></path>
          <path d="M9 16h6"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.incidents_actives }}</div>
    </div>
  </div>

  <div class="card">
    <div class="card-title"><p>Instalaciones Totales</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path d="M3 21l18 0"></path>
          <path d="M5 21v-14l8 -4v18"></path>
          <path d="M19 21v-10l-6 -4"></path>
          <path d="M9 9l0 .01"></path>
          <path d="M9 12l0 .01"></path>
          <path d="M9 15l0 .01"></path>
          <path d="M9 18l0 .01"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.installations }}</div>
    </div>
  </div>

  <div class="card">
    <div class="card-title"><p>Dashboards Totales</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
          ></path>
          <path
            d="M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
          ></path>
          <path
            d="M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
          ></path>
          <path d="M4 20h14"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.dashboards }}</div>
    </div>
  </div>

  <div class="card">
    <div class="card-title"><p>Incidencias Archivadas</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
          ></path>
          <path
            d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
          ></path>
          <path d="M9 12h6"></path>
          <path d="M9 16h6"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.incidents_archived }}</div>
    </div>
  </div>

  <div class="card">
    <div class="card-title"><p>Incidencias Notificadas</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
          ></path>
          <path
            d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
          ></path>
          <path d="M9 12h6"></path>
          <path d="M9 16h6"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.incidents_sended }}</div>
    </div>
  </div>

  <div class="card">
    <div class="card-title"><p>Cuadros Eléctricos Totales</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path d="M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
          <path
            d="M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z"
          ></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.cuadros }}</div>
    </div>
  </div>

  <div class="card">
    <div class="card-title"><p>Subsecciones Totales</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
          ></path>
          <path
            d="M4 14m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
          ></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.subsecciones }}</div>
    </div>
  </div>
</div>
